import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceVisit } from 'src/app/core/interfaces/service/service-visit';
import { ApiService } from 'src/app/core/services/api/api.service';

@Component({
  selector: 'app-service-management-counts-list',
  templateUrl: './service-management-counts-list.component.html',
  styleUrls: ['./service-management-counts-list.component.scss'],
})
export class ServiceManagementCountsListComponent implements OnInit {
  @Input() status: string;
  statusMessage: string;
  statusNumber: number;

  displayedColumns: string[] = [
    'customer',
    'serviceTypeName',
    'assignedName',
    'createdDate',
    'jobaddress',
    'reason',
    // 'serviceVisitId',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  serviceVisitArray: ServiceVisit[] = [];
  dataSource: MatTableDataSource<ServiceVisit>;

  isLoading: boolean = true;
  noResults: boolean = false;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();
    // this.getServiceVisits(this.status);
    this.route.paramMap.subscribe((params) => {
      this.status = params.get('status') as string;
      this.getServiceVisits(this.status);
    });
  }

  getServiceVisits(status: string) {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();

    if (status) {
      switch (status) {
        case 'serviceIncomplete':
          this.statusNumber = 4;
          this.statusMessage = 'Incomplete Service Visits';
          break;
        case 'serviceFinished':
          this.statusNumber = 3;
          this.statusMessage = 'Finished Service Visits';
          break;
      }
    }

    if (this.statusNumber != undefined) {
      this.apiService
        .getServiceManagementByStatus(this.statusNumber)
        .subscribe({
          next: (response) => {
            this.noResults = false;
            this.isLoading = false;
            this.serviceVisitArray = response;
            this.dataSource = new MatTableDataSource(this.serviceVisitArray);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          },
          error: (e) => {
            this.noResults = true;
            console.error(e);
          },
        });
    }
  }

  goToServiceVisit(row: ServiceVisit) {
    this.router.navigate(['customers/' + row.customerId], {
      queryParams: {
        jobAddressId: row.jobaddressId,
        serviceVisitId: row.serviceVisitId,
      },
    });
  }

  filterServiceVisits(event: Event) {
    const filterString = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterString.trim().toLowerCase();
  }
}
